export const startCarouselTileImageFunction = (element) => {
    var carousel = element ? $(element) : $('.js-tileImageCarousel');
    carousel.on('init', function (event, slick) {
        $(this).find('.tile-image').removeClass('hide');
        $(this).find('.slick-arrow').addClass('js-prevent-link');
    });
    carousel.slick({
        responsive: [
            {
                settings: {
                    draggable: false,
                    swipe: false,
                    swipeToSlide: false,
                    touchMove: false,
                    accessibility: false,
                    arrows: false
                }
            }
        ]
    });
};

class ProductBox {
    run () {
        this.gotoPDP();
        this.startCarouselTileImage();
        this.afterAttributesSelectionEvent();
    }

    gotoPDP () {
        $(document).on('click', '.product-tile', function (evt) {
            if (evt.target.classList.contains('js-prevent-link')) {
                evt.preventDefault();
            }
        });
    }

    startCarouselTileImage () {
        startCarouselTileImageFunction();

        $('body').on('click', '.product .js-tileImageCarousel .slick-arrow', function (e) {
            e.preventDefault();
            e.stopPropagation();
        });
    }

    afterAttributesSelectionEvent () {
        $(document).on('product:afterAttributeSelect', (evt, additionalData) => {
            const $container = additionalData.container;
            var newPriceData = additionalData.data.product.price.html;
            if (additionalData.data.product.doubleCurrency && additionalData.data.product.doubleCurrency.html) {
                newPriceData += additionalData.data.product.doubleCurrency.html;
            }
            $container.find('.price-container').html(newPriceData);
        });
    }
}

// const productBox = new ProductBox();
export default ProductBox;
